import React from "react";
import {message} from "antd";
import {useBaseComponent} from "../../../../base/base-component";
import BankDetailView from "./bank-detail.view";
import {useNavigate} from "react-router-dom";
import {IBankDetailFormModel, IBankDetailProps, IData, IState} from "./types/bank-detail.types";
import {viewMapper, modelMapper, fetchData} from "./action/bank-detail-actions";
import '../../../../styles/component/employee-create.scss';
import server from "../../../../server";
import DataLoading from "../../../../common/loading-data";

const initialState: IData = {
    bank: {
        id: '',
        name: '',
        accountHolderName: '',
        accountNumber: '',
        branchName: '',
        branchCode: '',
        ifscCode: ''
    }
}

const BankDetails = (props: IBankDetailProps) => {
    const navigate = useNavigate();

    const {state, updateState} = useBaseComponent<IBankDetailProps, IState>(props, {
        initialState: () => ({
            // data: initialState,
            internal: {
                loading: false,
                isFormValid: false
            },
            external: {}
        }),
        onInit: () => onInit()
    });

    const onInit = async () => {
        if (props.employeeId) {
            const data: IData = await fetchData(props.employeeId);
            updateState('data', data ?? initialState);
        } else {
            message.error("Initialization failed. Employee ID missing.");
        }
    };

    async function onSubmit(formValues: IBankDetailFormModel) {
        try {
            if (props.employeeId) {
                let bankDetailPayload = modelMapper(formValues);
                if (state.data?.bank?.id) {
                    bankDetailPayload['id'] = state.data.bank.id;
                    await server.employee.bank.update(props.employeeId, state.data.bank.id, bankDetailPayload);
                } else {
                    await server.employee.bank.create(props.employeeId, bankDetailPayload);
                }
            }
            message.success('Bank detail submitted successfully!');
        } catch {
            message.error('Submission Failed: something went wrong');
        }
    }

    return (
        state.data === undefined ? <DataLoading title="Bank Details"/> :
            <BankDetailView
                viewModal={viewMapper(state.data)}
                onSubmit={onSubmit}
            />
    );
}


export default BankDetails;
